import { camelCase } from 'lodash';
import { FieldGroup, FieldType } from 'components/molecules/views';
import { Item } from 'components/organisms/kanban-board/group-by';
import { pascalCase } from 'utils/pascal-case';

interface ToGroupProps {
  fieldsList: Item[];
  fieldName: string | null | undefined;
}

export const toGroup = ({
  fieldsList,
  fieldName,
}: ToGroupProps): FieldGroup | null => {
  if (!fieldName) {
    return null;
  }

  const field = fieldsList.find((f) => f.value === fieldName);

  if (!field) {
    return null;
  }

  if (field.isCustomField) {
    return {
      fieldId: field.fieldId,
      fieldClass: FieldType.Custom,
    };
  }
  if (field.value === 'None') {
    return null;
  }

  return {
    name: pascalCase(field.value),
    fieldClass: FieldType.Native,
  };
};

interface FromGroupProps {
  fieldsList: Item[];
  fieldGroup: FieldGroup | null | undefined;
  defaultValue: string;
}

export const fromGroup = ({
  fieldsList,
  fieldGroup,
  defaultValue,
}: FromGroupProps): string | null => {
  if (fieldGroup === null) {
    return null;
  }
  if (!fieldGroup) {
    return defaultValue;
  }

  if (fieldGroup.fieldClass === FieldType.Custom) {
    const field = fieldsList.find((f) => {
      return f.fieldId === fieldGroup.fieldId;
    });

    if (!field) {
      return defaultValue;
    }

    return field.value;
  }

  return camelCase(fieldGroup.name);
};
